import { useState } from "react";

type ItemValue = string | null;

type SetItemFunc = (value: ItemValue) => void;

type RemoveItemFunc = () => void;

export default function useLocalStorage(
  key: string,
  value?: ItemValue
): [ItemValue, SetItemFunc, RemoveItemFunc] {
  const [itemValue, setItemValue] = useState<ItemValue>(
    value || localStorage.getItem(key) || null
  );

  if (value) {
    localStorage.setItem(key, value);
  }

  const setItem = (value: string) => {
    localStorage.setItem(key, value);
    setItemValue(value);
  };

  const removeItem = () => {
    localStorage.removeItem(key);
    setItemValue(null);
  };

  return [itemValue, setItem, removeItem];
}
